<template>
    <VContent>
        <VContainer>
            <VLayout wrap>
                <VFlex xs12>
                    <a href="https://s3-us-west-2.amazonaws.com/coatesnhoff.com/img/CodeOfConduct.pdf" target="_blank">
                        Player Code of Conduct
                    </a>
                </VFlex>
            </VLayout>
        </VContainer>
    </VContent>
</template>

<script>
  export default {
    components: {},
    name: "forms",
    data() {
      return {}
    },
    mounted() {
    },
    methods: {}
  }
</script>

<style scoped>

</style>